import { createContext, ReactNode, useContext } from 'react'
import { OrgCredentialType } from '@/types/credentials'

type CredentialTypeContextValue = OrgCredentialType

const CredentialTypeContext = createContext<CredentialTypeContextValue>(
  {} as CredentialTypeContextValue,
)

export const useCredentialTypeContext = () => useContext(CredentialTypeContext)

type CredentialTypeProviderProps = {
  credentialType: OrgCredentialType
  children: ReactNode
}

export default function CredentialTypeProvider({
  credentialType,
  children,
}: CredentialTypeProviderProps) {
  return (
    <CredentialTypeContext.Provider value={credentialType}>
      {children}
    </CredentialTypeContext.Provider>
  )
}
